// apps/web/src/App.tsx
// 根组件 — 渲染路由

import { Toaster } from "react-hot-toast"; // 轻量 toast，V1 先用这个
import { Suspense } from "react";
import Layout from "@components/layout/Layout";
import AppRoutes from "./router";

export default function App() {
  return (
    <Layout>
      <Suspense fallback={<PageSkeleton />}>
        <AppRoutes />
      </Suspense>
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2500,
          style: {
            background: "#1F2937",
            color: "#F9FAFB",
            fontSize: "14px",
            borderRadius: "12px",
            padding: "12px 16px",
          },
        }}
      />
    </Layout>
  );
}

function PageSkeleton() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
